import { Link2 } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "@/design-system/lib/utils";
import type { TaskRelatedEntitySummaryDto } from "@/api/workTasks";

interface Props {
  related: TaskRelatedEntitySummaryDto | null | undefined;
  className?: string;
  showTypeLabel?: boolean;
}

const TYPE_LABEL: Record<string, string> = {
  Deal: "Deal",
  Broker: "Broker",
  Report: "Report",
  Loan: "Loan",
  Document: "Document",
  None: "",
};

export function TaskRelatedEntityLink({ related, className, showTypeLabel = true }: Props) {
  if (!related || related.type === "None") return null;

  const label = showTypeLabel
    ? `${TYPE_LABEL[related.type] ?? related.type}: ${related.displayName}`
    : related.displayName;

  if (!related.detailUrl) {
    return (
      <span
        className={cn(
          "inline-flex items-center gap-space-1 text-small text-gray-mid",
          className,
        )}
      >
        <Link2 size={14} aria-hidden /> {label}
      </span>
    );
  }
  return (
    <Link
      to={related.detailUrl}
      className={cn(
        "inline-flex items-center gap-space-1 text-small text-gold-shadow",
        "hover:underline underline-offset-4",
        className,
      )}
    >
      <Link2 size={14} aria-hidden /> {label}
    </Link>
  );
}
